import { get } from 'lodash';

export const getCurrentUser = (state) => get(state, ['auth', 'token', 'sub']);

export const getCurrentUserAssetListOptions = (state) => get(state, 'user.preferences.assetProperties');
